/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Features_MelonieInputs */

const en_testimonial_features_melonie = /** @type {(inputs: Testimonial_Features_MelonieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazingly fast to download and love being able to listen to papers as my eyes get tired when reading for long periods, where has this app been all my life!`)
};

const es_testimonial_features_melonie = /** @type {(inputs: Testimonial_Features_MelonieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increíblemente rápida de descargar y me encanta poder escuchar artículos ya que mis ojos se cansan al leer por períodos largos, ¡dónde ha estado esta app toda mi vida!`)
};

/**
* | output |
* | --- |
* | "Amazingly fast to download and love being able to listen to papers as my eyes get tired when reading for long periods, where has this app been all my life!" |
*
* @param {Testimonial_Features_MelonieInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_features_melonie = /** @type {((inputs?: Testimonial_Features_MelonieInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Features_MelonieInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_features_melonie(inputs)
	return en_testimonial_features_melonie(inputs)
});